import { Button } from "@/components/ui/baseUi/button"
import { Label } from "@/components/ui/baseUi/label"
import { word } from "@/modules/core/utils/i18n"
import { cn } from "@/modules/lib/utils"
import { EyeIcon, EyeOffIcon } from "lucide-react"
import { Text } from "@/components/ui/baseUi/text"

type ProfileLabelVisibilityProps = {
  name: string
  label: string
  isInvalid?: boolean
  isRequiredInput?: boolean
  displayVisibleToggle?: boolean
  visibility?: boolean
  onToggleVisibility?: () => void
}

export function ProfileLabelVisibility({
  name,
  label,
  isInvalid,
  isRequiredInput,
  displayVisibleToggle,
  visibility,
  onToggleVisibility,
}: ProfileLabelVisibilityProps) {
  return (
    <div className="flex items-center justify-between">
      <Label htmlFor={name} className={cn("text-xs font-medium text-textDefault-body", { "text-red-500": isInvalid })}>
        {label.toUpperCase()}
        {isRequiredInput && (
          <Text fontStyle="LL" className="text-red-500">
            {" "}
            *
          </Text>
        )}
      </Label>

      {/* Visibility toggle button */}
      {displayVisibleToggle && (
        <Button
          variant="ghost"
          size="xs"
          onClick={() => onToggleVisibility?.()}
          className="h-5 border-transparent text-neutral-600 hover:text-primary-600 hover:ring-0"
          title={word("profile.form.visibility.tooltip")}
          type="button"
        >
          {visibility ? (
            <EyeIcon className="size-5" color="currentColor" />
          ) : (
            <EyeOffIcon className="size-5" color="currentColor" />
          )}
        </Button>
      )}
    </div>
  )
}
